import isEmpty from 'lodash/isEmpty';

import { buildDocumentPreviewRows } from '@/features/ui/DocumentsData/model/preview';

import { Grid } from '@/shared/ui';

export const buildDocumentsDataPreview = (documents: Nullable<any>, additional_info: Nullable<string>) => {
  const docs = Array.isArray(documents) ? documents : [];

  const docsBlocks = docs.length
    ? docs.map((doc) => {
        const rows = buildDocumentPreviewRows(doc, 'Вкладення');
        const title = doc.fileName;
        const key = doc?.type?.id || doc?.type?.code;
        return <Grid key={key} title={title} data={rows} />;
      })
    : [];

  const infoRows: Array<[string, Nullable<string>]> =
    additional_info && !isEmpty(additional_info) ? [['Додаткові відомості', additional_info]] : [];

  return { docsBlocks, infoRows };
};
